"use client";

import { fetchGetCompanyBusinessHours, fetchGetCompanySubsidiaries } from "@/services/api";
import { useState, useEffect } from "react";

export default function Footer({ company }) {

    const [businessHours, setBusinessHours] = useState([]);

    useEffect(() => {
        const fetchBusinessHours = async () => {
            const hours = [];
            try {
                const res = await fetchGetCompanyBusinessHours();

                const hasAllWeekDays = res.monday && res.tuesday && res.wednesday && res.thursday && res.friday;

                if (hasAllWeekDays) {
                    const sameWeekdayHours =
                        res.mondayOpeningTime === res.tuesdayOpeningTime &&
                        res.mondayOpeningTime === res.wednesdayOpeningTime &&
                        res.mondayOpeningTime === res.thursdayOpeningTime &&
                        res.mondayOpeningTime === res.fridayOpeningTime &&
                        res.mondayClosingTime === res.tuesdayClosingTime &&
                        res.mondayClosingTime === res.wednesdayClosingTime &&
                        res.mondayClosingTime === res.thursdayClosingTime &&
                        res.mondayClosingTime === res.fridayClosingTime;

                    if (sameWeekdayHours) {
                        hours.push({
                            name: 'Segunda à Sexta',
                            openingTime: res.mondayOpeningTime.slice(0, 5),
                            closingTime: res.mondayClosingTime.slice(0, 5)
                        });
                    } else {
                        if (res.monday) {
                            hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                        }
                        if (res.tuesday) {
                            hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                        }
                        if (res.wednesday) {
                            hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                        }
                        if (res.thursday) {
                            hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                        }
                        if (res.friday) {
                            hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                        }
                    }
                } else {
                    if (res.monday) {
                        hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                    }
                    if (res.tuesday) {
                        hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                    }
                    if (res.wednesday) {
                        hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                    }
                    if (res.thursday) {
                        hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                    }
                    if (res.friday) {
                        hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                    }
                }

                if (res.saturday) {
                    hours.push({ name: 'Sábado', openingTime: res.saturdayOpeningTime.slice(0, 5), closingTime: res.saturdayClosingTime.slice(0, 5) });
                }

                if (res.sunday) {
                    hours.push({ name: 'Domingo', openingTime: res.sundayOpeningTime.slice(0, 5), closingTime: res.sundayClosingTime.slice(0, 5) });
                }

                if (res.holiday) {
                    hours.push({ name: 'Feriado', openingTime: res.holidayOpeningTime.slice(0, 5), closingTime: res.holidayClosingTime.slice(0, 5) });
                }

                setBusinessHours(hours);
            } catch (error) {
                console.error('Erro ao buscar os horários de funcionamento:', error);
            }
        };

        fetchBusinessHours();
    }, []);

    // const cnpjMask = (number) => {
    //     number.replace(/\D/g, '');
    //     return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5")
    // }

    const [subsidiaries, setSubsidiaries] = useState([])
    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet,
                    whatsapp: item.whatsapp,
                    phone: item.phone,
                    email: item.email
                }))
                setSubsidiaries(subs)
            })
    }, [])

    const message = `Olá, gostaria de informações sobre a ${company.nickName}`;

    return (
        <footer className="site-footer theme-pl-30 theme-pr-30">
            <div className="content-footer">
                <div className="row footer-content">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30">
                        <div className="footer-title">
                            <i className="mdi mdi-map-marker-outline"></i>
                            <h3>{subsidiaries.length > 0 ? "NOSSAS UNIDADES" : "NOSSA LOJA"}</h3>
                        </div>
                        <div>
                            {subsidiaries.length > 0 ?
                                <h3 className="footer-widget-title"><i className="mdi mdi-office-building"></i>{subsidiaries.length > 0 ? "Matriz" : "Localização"}</h3>
                                : null
                            }
                            <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                <li>
                                    <div>
                                        <i className="mdi mdi-map-marker"></i>
                                        {company.address}<br />{`${company.city} - ${company.federativeUnit}`}
                                    </div>
                                </li>
                            </ul>
                            <div className="footer__social">
                                <ul className="social-icons social-icons-gray color-hover mt-3">
                                    <li className="social-google-maps">
                                        <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(company.address + ', ' + company.city + ' - ' + company.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="mdi mdi-google-maps"></i>
                                        </a>
                                    </li>
                                    <li className="social-waze">
                                        <a href={`https://waze.com/ul?q=${encodeURIComponent(`${company.address}, ${company.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                            <i className="mdi mdi-waze"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {subsidiaries.length > 0 ?
                            subsidiaries.map((item, index) => (
                                <div key={index}>
                                    <div className="separator"></div>
                                    <h3 className="footer-widget-title"><i className="mdi mdi-office-building"></i>Filial {index + 1}</h3>
                                    <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                        <li>
                                            <div>
                                                <i className="mdi mdi-map-marker"></i>
                                                {item.address}<br />{`${item.city} - ${item.federativeUnit}`}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="footer__social">
                                        <ul className="social-icons social-icons-gray color-hover mt-3">
                                            <li className="social-google-maps">
                                                <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(item.address + ', ' + item.city + ' - ' + item.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                                    <i className="mdi mdi-google-maps"></i>
                                                </a>
                                            </li>
                                            <li className="social-waze">
                                                <a href={`https://waze.com/ul?q=${encodeURIComponent(`${item.address}, ${item.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                                    <i className="mdi mdi-waze"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            ))
                            : null}
                    </div>
                    <div className="separator d-none"></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30">
                        <div className="footer-title">
                            <i className="mdi mdi-phone-outline"></i>
                            <h3>CONTATOS</h3>
                        </div>
                        <div>
                            {subsidiaries.length > 0 ?
                                <h3 className="footer-widget-title"><i className="mdi mdi-office-building"></i>{subsidiaries.length > 0 ? "Matriz" : "Contatos"}</h3>
                                : null}
                            <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                <li>
                                    <div>
                                        <i className="mdi mdi-phone-incoming-outline"></i>
                                        <a href={`tel:+55${company.phone}`} rel="nofollow" target="_blank" title={company.nickName}>
                                            {
                                                company.phone.length === 10
                                                    ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                                    : company.phone.length === 11
                                                        ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                                        : company.phone
                                            }
                                        </a>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <i className="mdi mdi-whatsapp"></i>
                                        {
                                            company.whatsapp.length === 10
                                                ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 6)}-${company.whatsapp.substring(6, 10)}`
                                                : company.whatsapp.length === 11
                                                    ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 7)}-${company.whatsapp.substring(7, 11)}`
                                                    : company.whatsapp
                                        }
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <i className="mdi mdi-email"></i>
                                        {company.email}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        {subsidiaries.length > 0 ?
                            subsidiaries.map((item, index) => (
                                <div key={index}>
                                    <div className="separator"></div>
                                    {subsidiaries ?
                                        <h3 className="footer-widget-title"><i className="mdi mdi-office-building"></i>Filial {index + 1}</h3>
                                        : null}
                                    <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                        <li>
                                            <div>
                                                <i className="mdi mdi-phone-incoming-outline"></i>
                                                <a href={`tel:+55${item.phone}`} rel="nofollow" target="_blank" title={item.nickName}>
                                                    {item.phone ?
                                                        item.phone.length === 10
                                                            ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 6)}-${item.phone.substring(6, 10)}`
                                                            : item.phone.length === 11
                                                                ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 7)}-${item.phone.substring(7, 11)}`
                                                                : item.phone
                                                        : null}
                                                </a>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <i className="mdi mdi-whatsapp"></i>
                                                {item.whatsapp ?
                                                    item.whatsapp.length === 10
                                                        ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 6)}-${item.whatsapp.substring(6, 10)}`
                                                        : item.whatsapp.length === 11
                                                            ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 7)}-${item.whatsapp.substring(7, 11)}`
                                                            : item.whatsapp
                                                    : null}
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <i className="mdi mdi-email"></i>
                                                {item.email ? item.email : null}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            ))
                            : null}
                    </div>
                    <div className="separator d-none"></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30">
                        <div className="footer-title">
                            <i className="mdi mdi-account-group-outline"></i>
                            <h3>SIGA-NOS</h3>
                        </div>
                        <div>
                            <ul style={{gap: "10px"}} className="social-media-icons social-media-icons-gray color-hover d-flex mt-3 pr-4 pl-4 flex-wrap">
                                {company.instagram ?
                                    <li className="social-insta">
                                        <a href={company.instagram} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="mdi mdi-instagram"></i>
                                        </a>
                                    </li>
                                    : null}
                                {company.facebook ?
                                    <li className="social-facebook">
                                        <a href={company.facebook} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="mdi mdi-facebook"></i>
                                        </a>
                                    </li>
                                    : null}
                                {company.youtube ?
                                    <li className="social-youtube">
                                        <a href={company.youtube} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="mdi mdi-youtube"></i>
                                        </a>
                                    </li>
                                    : null}
                                {company.tiktok ?
                                    <li className="social-tiktok">
                                        <a href={company.tiktok} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="fa-brands fa-tiktok"></i>
                                        </a>
                                    </li>
                                    : null}

                            </ul>
                        </div>
                        {/* <div className="footer-title mt-4">
                            <i className="mdi mdi-file-document-outline"></i>
                            <h3>CNPJ</h3>
                        </div>
                        <div>
                            <ul className="social-media-icons social-media-icons-gray color-hover d-flex justify-content-start mt-3 text-start">
                                <li style={{ fontSize: "20px", color: "#FFFFFF" }}>{`${company.cnpj.substring(0, 2)}.${company.cnpj.substring(2, 5)}.${company.cnpj.substring(5, 8)}/${company.cnpj.substring(8, 12)}-${company.cnpj.substring(12, 14)}`}</li>
                            </ul>
                        </div> */}
                        <div className="footer-title mt-4">
                            <i className="mdi mdi-clock-outline"></i>
                            <h3>HORÁRIOS</h3>
                        </div>
                        <div>
                            <ul className="social-media-icons social-media-icons-gray color-hover d-flex flex-column">
                                {businessHours.map((hour, index) => (
                                    <li key={index} style={{ fontSize: "16px", color: "#FFFFFF" }}>
                                        {hour.name} : {hour.openingTime} - {hour.closingTime}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="separator d-none"></div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 theme-mb-30">
                        <div className="footer-title">
                            <i className="mdi mdi-diamond-stone"></i>
                            <h3>POR QUE ESCOLHER A {company.nickName}?</h3>
                        </div>
                        <div>
                            <ul className="list-unstyled footer-widget-contact theme-mt-20">
                                <li>
                                    <div className="d-flex align-items-center justify-content-start">
                                        <i style={{ fontSize: "45px" }} className="mdi mdi-shield-check-outline"></i>
                                        <p style={{ fontSize: "20px" }} className="mb-0">Negócios Seguros</p>
                                    </div>
                                </li>
                                <li style={{marginTop: "-25px"}}>
                                    <div className="separator"></div>
                                    <div className="d-flex align-items-center justify-content-start">
                                        <i style={{ fontSize: "45px" }} className="mdi mdi-certificate-outline"></i>
                                        <p style={{ fontSize: "20px" }} className="mb-0">Atendimento Personalizado</p>
                                    </div>
                                    <div className="separator"></div>
                                </li>
                                <li style={{marginTop: "-25px"}}>
                                    <div className="d-flex align-items-center justify-content-start">
                                        <i style={{ fontSize: "45px" }} className="mdi mdi-account-check-outline"></i>
                                        <p style={{ fontSize: "20px" }} className="mb-0">Compromisso com o Cliente</p>
                                    </div>
                                </li>
                            </ul>
                            <div className="footer__social">


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="auto-container copyright content-footer">
                <div className="row align-items-center">
                    <div className="col-md-12 text-center wow fadeIn" data-wow-delay="400ms">
                        <p>Copyright © Todos os direitos reservados -
                            <a href="https://bndv.com.br" target="_blank" title="BNDV - Banco Nacional de Veículo - Sistema para revenda de veículos"> Desenvolvido por BNDV </a> -
                            <a href="/politica-de-privacidade" title="Conheça nossa política de Privacidade"> Política de Privacidade</a>
                        </p>
                    </div>
                </div>
            </div>
        </footer >
    );
}